export const SITE_NAME =
  "Centre de Chirurgie de la Main et du membre supérieur Paris 15 (CCMP15)";
export const CREATOR = "Axel Delcros";
